import React, { useEffect, useState } from 'react';
import { Switch } from '@headlessui/react';
import { useSocket } from 'providers/SocketProvider';

export const UserStatus = ({ token, collapsed }) => {
  const { socket, isConnected, error } = useSocket();
  const [isOnline, setIsOnline] = useState(false);
  const [hasConnectedOnce, setHasConnectedOnce] = useState(false);

  // On first successful connect, mark user as online
  useEffect(() => {
    if (isConnected && !hasConnectedOnce) {
      setIsOnline(true);
      setHasConnectedOnce(true);
    }
  }, [isConnected, hasConnectedOnce]);

  // If connection drops after being online, update status
  useEffect(() => {
    if (!isConnected && isOnline) {
      setIsOnline(false);
    }
  }, [isConnected]);

  const handleToggle = (enabled) => {
    setIsOnline(enabled);
    if (socket && token) {
      socket.emit(
        'socket/admin/status',
        token,
        enabled ? 'active' : 'inactive'
      );
    }
  };

  const handleRefresh = () => {
    window.location.reload(); // Full page reload
  };

  return (
    <div className="glass-panel px-5 py-4 mb-3 rounded-2xl flex items-center justify-between shadow-lg border border-white/10">
      <div className="flex items-center gap-3">
        <span
          className={`w-3 h-3 rounded-full ${
            isConnected ? 'bg-green-500' : 'bg-red-500'
          }`}
        />
        {!collapsed && (
          <div className="flex flex-col">
            <span className="text-sm font-medium text-white/90">
              {isConnected ? (isOnline ? 'Online' : 'Away') : 'Offline'}
            </span>

            {!isConnected && (
              <span className="text-xs text-white/70 mt-1">
                Connection lost.{' '}
                <button
                  onClick={handleRefresh}
                  className="underline hover:text-white transition"
                >
                  Refresh
                </button>{' '}
                to restore.
              </span>
            )}
          </div>
        )}
      </div>

      {!collapsed && (
        <Switch
          checked={isOnline}
          onChange={handleToggle}
          disabled={!isConnected}
          className={`${
            isOnline ? 'bg-green-600' : 'bg-gray-500'
          } relative inline-flex h-5 w-10 items-center rounded-full transition-opacity ${
            isConnected ? 'opacity-100' : 'opacity-50 cursor-not-allowed'
          }`}
        >
          <span
            className={`${
              isOnline ? 'translate-x-5' : 'translate-x-1'
            } inline-block h-3 w-3 transform rounded-full bg-white transition`}
          />
        </Switch>
      )}
    </div>
  );
};
